import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types'; // ES6
import { Select, Card } from 'antd';

import AvisIntroduccioSeccioDadesMeteorCamps from './avisIntroduccioSeccioDadesMeteorCamps';
import PopoverError from '../commons/popoverError';
import { avisIntroduccioInicialitzarValors, avisIntroduccioModificarMeteor } from '../../actions';

const Option = Select.Option;

class AvisIntroduccioSeccioDadesMeteor extends Component {

    constructor(props) {
        super(props);
        this.onChangeSelect = this.onChangeSelect.bind(this);

    }

    onChangeSelect(idMeteorSeleccionat) {
        const { avisIntroduccioInicialitzarValors, avisIntroduccioModificarMeteor } = this.props;
        avisIntroduccioInicialitzarValors();
        avisIntroduccioModificarMeteor(idMeteorSeleccionat);
    }

    renderCampsMeteor(meteors, idMeteorSeleccionat) {

        let componentCampsMeteor = null;

        if (meteors[idMeteorSeleccionat]) {
            componentCampsMeteor = <AvisIntroduccioSeccioDadesMeteorCamps campsMeteor={meteors[idMeteorSeleccionat].camps} />;
        }

        return componentCampsMeteor;
    }

    renderLlistaMeteors(meteors) {
        return Object.keys(meteors).map(idMeteorText => {
            const idMeteor = Number(idMeteorText);
            const meteor = meteors[idMeteor];
            return (
                <Option
                    key={idMeteor}
                    value={idMeteor}>
                    {meteor.nom}
                </Option>
            );
        });
    }

    render() {

        const { meteors, idMeteorSeleccionat, error } = this.props;
        const errorRenderitzat = (error) ? <PopoverError contingut='Camp obligatori' classNameIcona='icona-error' /> : null;

        // Cal que el Select tingui valor undefined per tal de mostrar el placeholder (no el mostra si té valor null)
        const valorSelectMeteor = (idMeteorSeleccionat || idMeteorSeleccionat === 0) ? idMeteorSeleccionat : undefined;

        return (
            <Card title="Dades de l'avís">
                <div className='selector-meteor'>
                    <span className='titol'>
                        Meteor:
                    </span>
                    <Select
                        placeholder='Selecciona un meteor'
                        onChange={this.onChangeSelect}
                        value={valorSelectMeteor}
                    >
                        {this.renderLlistaMeteors(meteors)}
                    </Select>
                    {errorRenderitzat}
                </div>
                { this.renderCampsMeteor(meteors, idMeteorSeleccionat) }
            </Card>
        );
    }
}

AvisIntroduccioSeccioDadesMeteor.propTypes = {
    meteors: PropTypes.object,
    idMeteorSeleccionat: PropTypes.number,
    error: PropTypes.bool,
    avisIntroduccioInicialitzarValors: PropTypes.func,
    avisIntroduccioModificarMeteor: PropTypes.func
};

const mapStateToProps = (state) => ({
    meteors: state.avis.meteors,
    idMeteorSeleccionat: state.avis.formulari.dades.idMeteorSeleccionat,
    error: state.avis.formulari.errors.idMeteorSeleccionat
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        avisIntroduccioInicialitzarValors,
        avisIntroduccioModificarMeteor
    }, dispatch);
};


export default connect(mapStateToProps, mapDispatchToProps)(AvisIntroduccioSeccioDadesMeteor);



// WEBPACK FOOTER //
// ./src/components/avis/avisIntroduccioSeccioDadesMeteor.js